import Utils from "../../../shared/utils";

export const FIRST_PART_ANIMATION = Utils.buildNewsletterLink(
  "popups/top-animation.svg"
);

export const DESKTOP_SPREAD = Utils.buildNewsletterLink("popups/desktop.svg");

export const MOBILE_SPREAD = Utils.buildNewsletterLink("popups/mobile.svg");
